import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mara = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Mobility Concept Partner in Ihrer Nähe",
      hero: {
        title: "Mobility Concept Terminbuchung",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu mobility-concept.de",
      },
      booking: {
        ...de_DE_formal.translation.booking,
        vehicleReturn: {
          headline: "Termine",
          submit: "Termin auswählen",
          tos: {
            headline: "Hinweise zur vorzeitigen Fahrzeugrückgabe",
            subheadline:
              "Der gewählte Termin zur Fahrzeugrückgabe liegt vor dem vereinbarten Vertragsende. Eine Rückgabe zu diesem Zeitpunkt stellt eine vorzeitige einvernehmliche Vertragsbeendigung dar.",
            text: "Mit der Vereinbarung der vorzeitigen Beendigung des Leasingvertrages entstehen für Sie Kosten, die sich zusammensetzen aus der Summe der noch bis zum regulären Vertragsende geschuldeten jeweils abgezinsten offenen Netto-Leasingraten nebst kalkuliertem Restwert (sowie der vereinbarten Netto-Rückgabeoptionsgebühr im Fall eines Vario-Finanzierungsvertrages) abzüglich des Netto-Händlereinkaufswertes zum Zeitpunkt der Rückgabe des Fahrzeuges. Eine Vergütung für Mehr- oder Minderkilometer entfällt dabei, während ein etwaiger Minderwertausgleich aufgrund des Erhaltungszustandes des Fahrzeuges und übrige vertragliche Kosten im Zuge der Rückgabe hiervon unberührt bleiben.",
          },
        },
        "daypicker-legend-yellow-94": "Vorzeitige Fahrzeugrückgabe verursacht Zusatzkosten",
        hint: " Die finale Terminbestätigung erfolgt durch die Prüfstelle. Bitte beachten Sie, dass bei einer Rückgabe nach Vertragsende etwaige Nachbelastungen entstehen können.",
      },
      contractDetails: {
        error: {
          general: `Etwas ist schiefgegangen. Bitte schreiben Sie eine E-Mail an <a>werkstattmeister@repareo.de</a>`,
          not_found:
            "Wir konnten anhand Ihrer Vertragsdaten keinen Vertrag finden. Bitte überprüfen Sie Ihre Vertragsdaten oder wenden Sie sich an Mobility Concept.",
          does_not_match:
            "Die eingegebenen Daten passen nicht zum gefundenen Vertrag. Bitte überprüfen Sie Vertragsnummer und Kennzeichen oder wenden Sie sich an Mobility Concept.",
          wrong_contract_type: `Zu Ihrer Vertragsnummer gehört kein MARA Leasingvertrag. Ihr Fahrzeug kann daher nicht über diese Seite zurückgegeben werden. Nutzen Sie bitte diesen Link: <a>Mobility Concept Fahrzeugrückgabe</a>`,
          cannot_book:
            "Zu früh dran! Der frühest mögliche Termin ist vier Wochen vor Vertragsende. Ab zwei Monate vor Vertragsende können Sie passende Termine einsehen und buchen.",
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mobility-concept",
    },
  },
};
